import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import * as React from "react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { editInvoice, getInvoiceById } from "../service/weexpertService";
import { toast } from '@/components/ui/use-toast';
import { useTranslation } from 'react-i18next';
import { InvoiceForm, MODE } from "@/components/forms/invoice";

const InvoiceEditPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getInvoiceById(id)
      .then(res => {
        setInvoice(res.data);
        setLoading(false);
      })
      .catch(error => {
        if (error.response && error.response.status === 404) {
          if (error.response.data && error.response.data.message === "Not found") {
            navigate('/404');
          }
        } else {
          console.error("Error:", error);
        }
        if (error.response && error.response.status === 400) {
          navigate('/404');
        } else {
          console.error("Error:", error);
        }
      });
  }, [id, navigate]);

  const handleSave = (invoiceData) => {
    const {
      client,
      invoiceType,
      issueDate,
      domainDate,
      status,
      counterpartyName,
      counterpartyOrigin,
      counterpartyNip,
      counterpartyEmail,
      counterpartyType,
      counterpartyAddress,
      counterpartyPostIndex,
      counterpartyCity,
      counterpartyCountry,
      typeOfPayment,
      wayOfPayment,
      paymentStatus,
      paymentDueDate,
      paymentCurrency,
      paymentCurrencyRate,
      paymentCurrencyRateDate,
      paymentIban,
      internalComment,
      externalComment,
      rows,
      invoiceBrutto,
      invoiceTotalNetto,
      invoiceVAT,
      newInvoiceId,
      useDifferentRecipient,
      recipientCounterparty,
      paymentSwift
    } = invoiceData;

    const processedInvoiceId = invoice.invoiceId === newInvoiceId ? null : newInvoiceId;

    return editInvoice(
      id,
      invoiceType,
      domainDate,
      status,
      counterpartyName,
      counterpartyType,
      counterpartyOrigin,
      counterpartyName,
      counterpartyPostIndex,
      counterpartyNip,
      counterpartyCity,
      counterpartyEmail,
      counterpartyCountry,
      counterpartyAddress,
      typeOfPayment,
      wayOfPayment,
      paymentStatus,
      paymentDueDate,
      paymentCurrency,
      paymentCurrencyRate,
      paymentIban,
      invoiceTotalNetto,
      invoiceBrutto,
      invoiceVAT,
      client.id,
      rows,
      internalComment,
      externalComment,
      paymentCurrencyRateDate,
      issueDate,
      useDifferentRecipient,
      {
        counterpartyType: recipientCounterparty.counterpartyType,
        name: recipientCounterparty.counterpartyName,
        address: recipientCounterparty.counterpartyAddress,
        postIndex: recipientCounterparty.counterpartyPostIndex,
        city: recipientCounterparty.counterpartyCity,
        email: recipientCounterparty.counterpartyEmail,
        country: recipientCounterparty.counterpartyCountry,
        NIP: recipientCounterparty.counterpartyNip,
        origin: recipientCounterparty.counterpartyOrigin
      },
      processedInvoiceId,
      paymentSwift
    )
      .then((response) => {
        if (response.status === 200) {
          toast({
            title: t("alerts:toast_succes_invoice_edit_title"),
            description: t("alerts:toast_succes_invoice_edit_description"),
          });
          navigate('/admin/invoices/sales');
        }
      })
      .catch((error) => {
        toast({
          title: t("alerts:toast_error_invoice_title"),
          description: t("alerts:toast_error_invoice_description"),
          variant: "destructive"
        });
        console.error(error);
      });
  };

  return (
    <Box sx={{ width: '100%' }}>
      {loading ? (
        <Box sx={{ width: "100%", height: '80vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row">
            <CircularProgress color="grey" />
          </Stack>
        </Box>
      ) : (
        <div className="relative bg-grayLightMainBg px-8">
          <InvoiceForm invoice={invoice} mode={MODE.EDIT} onSave={handleSave} />
        </div>
      )}
    </Box>
  );
};

export default InvoiceEditPage;
